'use es6';

import { AnchorIcon, ArtificialIntelligenceIcon, CtasIcon, EmbedIcon, EmojiIcon, HorizontalRuleIcon, InsertImageIcon, InsertVideoIcon, LinkIcon, LogoIcon, NonbreakingSpaceIcon, ReadMoreIcon, SocialRssIcon, SpacerIcon, SpecialCharacterIcon, TableIcon, TextSnippetIcon } from 'foundations-assets';
export const IconMap = {
  canvaslink: 'link',
  canvasimage: 'insertImage',
  canvasemoji: 'emoji',
  canvassnippet: 'textSnippet',
  canvascta: 'ctas',
  canvasembed: 'embed',
  canvasvideo: 'insertVideo',
  canvastable: 'table',
  canvascallout: 'spacer',
  canvasanchor: 'anchor',
  canvascharmap: 'specialCharacter',
  canvasmore: 'readMore',
  canvashr: 'horizontalRule',
  canvasnonbreaking: 'nonbreakingSpace',
  canvasrsstokens: 'socialRss',
  canvasicon: 'logo',
  canvascontentgeneration: 'artificialIntelligence',
  canvascopilotcollabortation: 'artificialIntelligence'
};
export const IconComponentMap = {
  canvaslink: LinkIcon,
  canvasimage: InsertImageIcon,
  canvasemoji: EmojiIcon,
  canvassnippet: TextSnippetIcon,
  canvascta: CtasIcon,
  canvasembed: EmbedIcon,
  canvasvideo: InsertVideoIcon,
  canvastable: TableIcon,
  canvascallout: SpacerIcon,
  canvasanchor: AnchorIcon,
  canvascharmap: SpecialCharacterIcon,
  canvasmore: ReadMoreIcon,
  canvashr: HorizontalRuleIcon,
  canvasnonbreaking: NonbreakingSpaceIcon,
  canvasrsstokens: SocialRssIcon,
  canvasicon: LogoIcon,
  canvascontentgeneration: ArtificialIntelligenceIcon,
  canvascopilotcollabortation: ArtificialIntelligenceIcon
};
export const SHOW_TOOLBAR_SHEPHERD = 'SHOW_TOOLBAR_SHEPHERD';
export const TOGGLE_MENU_ITEM_DISABLED_STATE_EVENT_NAME = 'toggleMenuItemDisabledState';